module.exports = __webpack_public_path__ + "img/BACKUP.b9d2a8a8.svg";